import { z } from 'zod';

import { positionDtoSchema } from '../position-geocode/position.dto.schema';

export const tourTravelDtoSchema = z.object({
  id: z.number(),
  sequenceId: z.string(),
  name: z.string(),
  connexionTypeWithEvent: z.string(),
  travelDistance: z.number(),
  fromEventId: z.string().nullable(),
  fromPosition: positionDtoSchema.nullable(),
  toEventId: z.string().nullable(),
  toPosition: positionDtoSchema.nullable(),
});

export const getTourTravelsDtoSchema = z.object({
  data: z.array(tourTravelDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type TourTravelDto = z.infer<typeof tourTravelDtoSchema>;
